export default __webpack_public_path__ + "static/media/det-aene-am-baergli.d10e60e4.png";